<!-- eslint-disable vue/no-parsing-error -->
<template>
  <footer>
    <div class="w clearfix overflow-hidden">
      <div class="module w-20 float-left border-right h-full">
        <div>
          <div class="title">联系我们</div>
          <ul class="content">
            <li>邮编：100191</li>
            <li>电话：010-62755591</li>
            <li>邮箱：aipku@pku.edu.cn</li>
          </ul>
        </div>
      </div>
      <div class="module module2 w-40 float-left border-right h-full">
        <div class="w-60">
          <div class="title">友情链接</div>
          <Row class="content">
            <Col
              span="12"
              v-for="link in links"
              :key="link.id"
              class="cursor-pointer"
              @click.native="windowOpen(link.link)"
            >
              {{ link.name }}
              <Icon type="ios-arrow-forward" class="float-right" />
            </Col>
          </Row>
        </div>
      </div>
      <div class="module w-20 float-left border-right h-full">
        <div>
          <div class="title">地图 <span>地址：北京市学院路38号</span></div>
          <div class="content map"></div>
        </div>
      </div>
      <div class="module w-20 float-left h-full">
        <div>
          <div class="title">二维码</div>
          <div class="content qrcode"></div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footer-nav',
  mixins: [],
  data() {
    return {
      links: [
        { id: '1', name: '北京大学第一医院', link: 'https://www.pkufh.com' },
        { id: '2', name: '北京大学人民医院', link: 'https://www.pkuph.cn' },
        { id: '3', name: '北京大学第三医院', link: 'https://www.puh3.net.cn' },
        { id: '4', name: '北京大学医学部', link: 'https://www.bjmu.edu.cn' },
        {
          id: '5',
          name: '北京大学肿瘤医院',
          link: 'https://www.bjcancer.org/Html/Index.html'
        }
      ]
    }
  },
  computed: {
    footerData() {
      let data = this.$store.getters['HomeStore/footer']
      return data
    },
    protocol() {
      return document.location.protocol
    }
  },
  methods: {
    windowOpen(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
footer {
  height: 240px; //12.5vw; //240px;
  padding-top: 56px; //2.92vw; //
  padding-bottom: 50px; //2.6vw; //
  background-color: #fafafa;
  .module {
    // padding-left: 72px;
    // padding: 0 auto;
    margin: 0 auto;
    text-align: center;
    // vertical-align: middle;
    > div {
      display: inline-block !important;
      text-align: left;
    }
  }
  .module2 {
    .ivu-col {
      margin-bottom: 0.625vw; //12px;
      padding-right: 2.92vw; //56px;
      transition: all 1s;
      -moz-transition: all 1s;
      -webkit-transition: all 1s;
      -o-transition: all 1s;
      &:hover {
        color: #46bfb8;
      }
      &:nth-child(2n) {
        padding-left: 2.92vw; //56px;
        padding-right: 0;
      }
    }
  }
  .title {
    padding-bottom: 0.57vw; //11px;
    font-size: 0.9375vw; //18px;

    color: #111a2e;
    span {
      padding-left: 2.08vw; //40px;
      font-size: 0.73vw; //14px;
      color: #333333;
      opacity: 0.8;
    }
  }
  .content {
    font-size: 0.73vw; //14px;

    color: #646a77;
    opacity: 0.8;
  }
  .map {
    width: 12.5vw; //240px;
    max-width: 240px;
    height: 4.84vw; //93px;
    max-height: 93px;
    background-image: url('/static/images/background/map.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .qrcode {
    width: 4.64vw; //89px;
    max-width: 89px;
    height: 4.64vw; //89px;
    max-height: 89px;
    background-image: url('/static/images/background/qrcode.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.w-20 {
  width: 20%;
}
.w-40 {
  width: 40%;
}
.w-60 {
  width: 60%;
}
.border-right {
  border-right: 1px solid #646a770d;
}
.mr-100px {
  margin-right: 5.2vw; //100px;
}
@media only screen and (min-width: 736px) {
}
@media only screen and (max-width: 735px) {
  footer {
    display: none;
  }
}
</style>
